import styled from 'styled-components';
import colors from '../../../../includes/colors';
import { theme } from '../../../styles';

const BoxCloseButton = styled.div`
  display: flex;
  border: 1px solid #eee;
  background-color: #eee;
`;

const CloseButton = styled.button`
  border: none;
  outline: none;
  box-shadow: none;
  font-size: 14px;
  color: #007db8;
  padding: 10px 20px;
  line-height: 20px;

  &:focus,
  &:hover {
    box-shadow: none;
    color: #00447c;

    span.text {
      text-decoration: underline;
    }
  }

  .dds__icons {
    font-size: 14px;
    transform: rotate(180deg);
    display: inline-block;
    margin-right: 5px;
  }
`;

const ContentWrapper = styled.div`
  overflow: auto;
  padding: 0 20px 30px;
`;

const MenuTitle = styled.h1`
  color: ${colors.black};
  font-size: 16px;
  font-weight: 400;
  margin: 25px 0 15px;
  line-height: 1;

  @media (min-width: ${theme.screenSize.sm}) {
    font-weight: 300;
    margin: 35px 0;
    font-size: 30px;
    line-height: 36px;
  }

  @media (min-width: ${theme.screenSize.md}) {
    font-size: 32px;
    line-height: 40px;
  }
`;

export { BoxCloseButton, CloseButton, MenuTitle, ContentWrapper };
